module.exports = __webpack_public_path__ + "img/rw.f6b6d25a.svg";